import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface TraditionalPriceColumnProps {
  formattedTraditionalPrice: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  updatedDesignForV2?: boolean
}

// Renders the strikethrough traditional price + "Traditional retail" caption, laid out inline
// when an offer price is present.
function TraditionalPriceColumn({
  formattedTraditionalPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  updatedDesignForV2,
}: TraditionalPriceColumnProps) {
  const { t } = useTranslation('common')
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const isOfferInline = !!(formattedFestivalOfferPrice || isSubscriptionOffer)
  return (
    <div className={isOfferInline ? styles.priceWrapperTraditionalRetailInlineCss : styles.priceWrapperMainCss}>
      <div
        className={cx(
          isOfferInline ? styles.priceWrapperMainValueRpOfferCss : styles.priceWrapperMainValueCss,
          styles.priceWrapperMainValueRpDecorationRecipe({ festival: false }),
          updatedDesignForV2 && styles.priceWrapperMainValueRpUpdatedDesignV2Css,
        )}
      >
        <span className="traditionalPrice_selector_for_force_update">
          <FormattedPrice amount={formattedTraditionalPrice} />
        </span>
      </div>

      <div
        className={cx(
          styles.priceWrapperMainTextCss,
          styles.priceWrapperMainTextRpCss,
          !isOfferInline && styles.priceWrapperMainMarginCss,
          updatedDesignForV2 && styles.priceWrapperMainTextUpdatedDesignV2Css,
        )}
      >
        {t('traditional_retail')}
      </div>
    </div>
  )
}

export default TraditionalPriceColumn
